// extracted by mini-css-extract-plugin
module.exports = {"categories":"Categories_categories__zDOY0","categories__cards":"Categories_categories__cards__1D0K3"};